import React from 'react';
import { navigationItems } from '../data/navigation';

export function Sidebar({ currentView, onChangeView, user, onLogout }) {
  const access = user?.access || {};
  const roles = user?.roles || [];
  const allowedItems = navigationItems.filter((item) => {
    if (!access[item.accessKey]?.view) {
      return false;
    }

    if (!item.requiredRoles?.length) {
      return true;
    }

    return item.requiredRoles.some((role) => roles.includes(role));
  });

  return (
    <aside className="admin-sidebar">
      <div className="brand-block">
        <div className="brand-mark">PP</div>
        <div>
          <h1>Perifa Pro</h1>
          <p>Central da liga</p>
        </div>
      </div>

      <div className="tenant-card">
        <span className="eyebrow">Operador da rodada</span>
        <strong>{user?.name || 'Administrador'}</strong>
        <p>{user?.email}</p>
        <small>{(user?.roles || []).join(' • ')}</small>
      </div>

      <nav className="nav-list">
        {allowedItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${currentView === item.id ? 'is-active' : ''}`}
            onClick={() => onChangeView(item.id)}
          >
            <span className="nav-icon">{item.icon}</span>
            <span>{item.label}</span>
          </button>
        ))}
      </nav>

      <button className="logout-button" onClick={onLogout}>Encerrar sessão</button>
    </aside>
  );
}
